<form class="mr-5 ml-5 mt-5 mb-3" (ngSubmit)="goPaso()">
  <app-ayudas
    [ayuda]="ayudaService.fontur(
      datoSolicitudSharedModel.tipo_solicitud, 
      datoSolicitudSharedModel.tipo_rnt, 
      rnt.sub_categoria_id,
      rnt.estado_rnt_id,
      rnt.estado_solicitud_id )">
  </app-ayudas>
  <section class="row border-bottom mb-4">

    <header class="row form-group d-flex align-items-center">
      <figure class="m-auto">
        <img src="../../../../../../../../assets/icons/solicitud.png" class="d-inline-block p-2 rounded-circle" alt=""
          height="60">
      </figure>
      <div class="col">
        <label class="text-muted small mb-0 ml-1">Validación <br><strong class="h5 text-body">FONTUR</strong></label>
      </div>
    </header>
  </section>
  <section class="row border-bottom mb-4 text-center">
    <header class="col-12">
      <figure class="figure w-100">
        <img *ngIf="validacionFontur === 0" class="img-fluid mb-4"
          src="../../../../../../../../assets/icons/fontur_ok.png" />
        <img *ngIf="validacionFontur === 1" class="img-fluid mb-4"
          src="../../../../../../../../assets/icons/fontur_bad.png" />
        <img *ngIf="validacionFontur === 2" class="img-fluid mb-4"
          src="../../../../../../../../assets/icons/fontur_bad.png" />
          <img *ngIf="validacionFontur === 3" class="img-fluid mb-4"
          src="../../../../../../../../assets/icons/fontur_bad.png" />
        <figcaption>
          <div class="h3 text-muted" [innerHTML]="mensajeFontur" ></div>
        </figcaption>
      </figure>
    </header>
    <footer class="col-md-6 m-auto">
      <!-- <p class="text-muted">Puede continuar con el proceso.</p> -->
     <b><p *ngIf="validacionFontur === 0" class="text-muted tamanoLetra">Puede continuar con el proceso.</p></b>
     <b><p *ngIf="validacionFontur === 1" class="text-muted tamanoLetra">Puede continuar con el proceso.</p></b>
     <b><p *ngIf="validacionFontur === 2" class="text-muted">No puede continuar con el proceso.</p></b>
     <b><p *ngIf="validacionFontur === 3" class="text-muted tamanoLetra">Puede continuar con el proceso de radicación dando Clic en el botón finalizar.</p></b>
    </footer>
  </section>
  <footer class="text-right p-3">
    <button type="button" class="btn btn-outline-primary paso-encuesta-btn-inicio mr-2 pl-4 pr-4"
      (click)="onRegresarPaso()">Revisar</button>
    <button type="submit" class="btn btn-primary paso-encuesta-btn-inicio">{{btnString}}</button>
  </footer>
</form>
